import { inject } from 'tsyringe'
import { Store } from 'vuex'
import { ClientOnly } from '~/decorators'
import { containerScoped } from '~/decorators/dependency-container'
import { QUANTCAST_COOKIE_DURATION } from '~/constants/duration'
import { Policy } from '~/models/shared/types'
import CookiesService from '~/services/CookiesService'
import GoogleAdsService from '~/services/ads/GoogleAdsService'
import { PrivacyPolicyChecker } from '~/services/PrivacyPolicyChecker'
import { SET_POLICIES } from '~/store/modules/shared/page/mutation-types'
import { PAGE_NS } from '~/store/modules/shared/page/state'
import { RootState } from '~/store/types'
import { APP_NS } from '~/store/modules/shared/app/state'

// DISCLAIMER: these cookies are used by old car also, change with extra caution
export const POLICY_COOKIE_NAME = 'policy'
export const COOKIE_BANNER_COOKIE_NAME = 'cookiewarning'

export const PLOT_COOKIE_BANNER_COOKIE_NAME = 'cookieDisclaimer' // same as plot1

@ClientOnly
@containerScoped()
export default class PrivacyService {
  constructor(
    @inject(Store) private store: Store<RootState>,
    @inject(CookiesService) private cookies: CookiesService,
    @inject(GoogleAdsService) private googleAdsService: GoogleAdsService,
    @inject(PrivacyPolicyChecker)
    private privacyPolicyChecker: PrivacyPolicyChecker
  ) {}

  selectPolicies(policies: Policy[] = []) {
    this.cookies.set(POLICY_COOKIE_NAME, JSON.stringify(policies), {
      maxAge: QUANTCAST_COOKIE_DURATION
    })

    let cookieKey = COOKIE_BANNER_COOKIE_NAME

    if (this.store.getters[`${APP_NS}/isPlot`]) {
      cookieKey = PLOT_COOKIE_BANNER_COOKIE_NAME
    }
    this.cookies.set(cookieKey, 1, {
      maxAge: QUANTCAST_COOKIE_DURATION
    })
    this.store.commit(`${PAGE_NS}/${SET_POLICIES}`, policies, { root: true })
    const advertisingPolicyExists = policies.includes(Policy.ADVERTISING)
    this.googleAdsService.setNonPersonalizedAds(!advertisingPolicyExists)
  }

  acceptAllPolicies(): void {
    this.selectPolicies([
      Policy.PERFORMANCE,
      Policy.ADVERTISING,
      Policy.ESSENTIAL
    ])
  }

  policyWithNameExists(policy: Policy): boolean {
    return this.privacyPolicyChecker.policyWithNameExists(policy)
  }
}
